import ExpressionLayout from "./ExpressionLayout";
import { tundala } from "./data";

const TundalaPage = () => <ExpressionLayout data={tundala} />;

export default TundalaPage;
